module.exports = __webpack_public_path__ + "static/media/painting.5fca0277.png";